export enum Breakpoint {
  sm = 320,
  md = 500,
  lg = 768,
  xl = 1040,
  xl2 = 1200,
}

export const breakpoints = {
  sm: Breakpoint.sm,
  md: Breakpoint.md,
  lg: Breakpoint.lg,
  xl: Breakpoint.xl,
  '2xl': Breakpoint.xl2,
};
